module.exports = __webpack_public_path__ + "img/hn.e4953d7b.svg";